import { useEffect } from 'react';

import { FabricObjectWithSrc, extractFabricObjectMovementProperties, shallowCompare, sortImagesAscFunction } from '../../../../shared/Helpers';

function useUpdateImages(canvasEl: Nullable<fabric.Canvas>, lastImages: FabricObjectWithSrc[], reRender: boolean) {
  useEffect(() => {
    if (canvasEl && reRender && lastImages.length) {
      const objects = canvasEl.getObjects();

      canvasEl.discardActiveObject(); 

      lastImages.sort(sortImagesAscFunction).forEach(image => {
        const object = objects.find(x => x.data.name === image.name);
        if (object) {
          const isEqual = shallowCompare(image, extractFabricObjectMovementProperties(object as any));

          if (!isEqual) {
            Object.assign(object, image);
          }

          canvasEl!.bringToFront(object);
        }
      });

      canvasEl.defaultCursor = 'grabbing';
      canvasEl.renderAll();
    }
  }, [canvasEl, lastImages, reRender]);
}

export default useUpdateImages;
